module.exports = __webpack_public_path__ + "images/icons_v2/arrow-up-18d83661.svg";